import React, { useRef, useState } from "react";
import { Whisper, Popover } from "rsuite";
import {
  MdOutlineVisibility,
  MdOutlineEdit,
  MdOutlineUpdate,
  MdOutlineHistory,
} from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import UpdateStockModal from "../pharmacy/UpdateStockModal";

const ActionCellPescriptionintegration = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const triggerRef = useRef(null);

  const closePopover = () => {
    if (triggerRef.current) {
      triggerRef.current.close();
    }
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-44">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      <div
        onClick={() => {
          navigate("/PharmacyintegrationDetails");
          closePopover();
        }}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <MdOutlineVisibility className="text-lg text-gray-500" />
        <span>View Details</span>
      </div>

      
    </Popover>
  );

  return (
    <>
      <UpdateStockModal open={modalOpen} onClose={() => setModalOpen(false)} />
      <Whisper
      ref={triggerRef}
        placement="topEnd"
        trigger="click"
        speaker={renderPopover}
      >
        <button
          className="inline-flex items-center justify-center gap-2 w-10 h-10 rounded-md hover:bg-gray-100"
          title="More actions"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="lucide lucide-ellipsis h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="19" cy="12" r="1"></circle>
            <circle cx="5" cy="12" r="1"></circle>
          </svg>
        </button>
      </Whisper>
    </>
  );
};

export default ActionCellPescriptionintegration;
